module.exports = __webpack_public_path__ + "media/images/icon/profit-black-3e2cc61a6c3e906bc236bf80833ba0bb.svg";